import React, { useState } from "react";
import { MDBIcon } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";

function CFAnalytics(props) {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const [showAnalytics, setShowAnalytics] = useState(false);
  const toggleAnalytics = () => {
    props.toggleAnalytics();
  };

  return (
    <>
      <div className="float-left w-15 p-3">
        <div className="d-flex align-items-center justify-content-between">
          <MDBIcon fas icon="times" onClick={toggleAnalytics} />{" "}
          <b>Call Analytics</b>
          <div className="CallAnalytics-select">
            <select className="form-control form-select">
              <option value="none">Last 7 days</option>
              <option value="none">Last month</option>
              <option value="none">Last 3 months</option>
              <option value="none">Last 7 days</option>
            </select>
          </div>
        </div>

        <div className="mt-4">
          <p className="p-0">Node Type: --</p>
          <p className="p-0">Name: --</p>
        </div>
        <div className="routing-border m-0 pt-2"></div>
        <div className="d-flex align-items-center justify-content-between pt-3">
          <b>Total incoming calls</b>
          <p className="m-0">0</p>
        </div>
        <b>Assigned Keys</b>
        <div className="d-flex align-items-center justify-content-between pt-1">
          <p>Key 0</p>
          <p className="m-0">0 (0%)</p>
        </div>
        <div className="d-flex align-items-center justify-content-between pt-1">
          <p>Key 1</p>
          <p className="m-0">0 (0%)</p>
        </div>
        <b>Additional details</b>

        <div className="d-flex align-items-center justify-content-between pt-1">
          <p>Timeout</p>
          <p className="m-0">0 (0%)</p>
        </div>

        <div className="nodeCallAnalytics-box">
          <p>Users that either timed out or selected invalid options</p>
        </div>
      </div>
    </>
  );
}

export default CFAnalytics;
